// This can be false if you're using a fallback (i.e. SPA mode)
import { isPresent } from '@yp/common/identity.ts';
import { checkVersion } from '@yp/web.app/api/version.ts';
import { checkUpdate } from '@yp/web.app/client/pwa/update.ts';
import type { Breadcrumb } from '@yp/web.app/nav.ts';
import type { LayoutLoad } from './$types.ts';

// https://kit.svelte.dev/docs/adapter-static#usage

// export const ssr = false;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const prerender = true;

// The following is required to generate foo/index.html instead of foo.html, so that even staticly
// generated sites can use non-html suffixes.
// eslint-disable-next-line @typescript-eslint/naming-convention
export const trailingSlash = 'always';

const breadcrumb: Breadcrumb = {
  // DNS: load title from somewhere.
  label: 'McBarron NYE Bash',
  // icon: 'home',
  path: '/',
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const load: LayoutLoad = async ({ fetch }) => {
  const version = (await checkVersion('/api/version', fetch))?.version;
  if (isPresent(version) && checkUpdate(version)) {
    window.location.reload();
  }
  return { crumbs: [breadcrumb], version };
};
